import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { chatsTab } from "../../helper/utils";
import "./navbar.css";
import { ReactComponent as Logo2 } from "../../assets/icons/Logo2.svg";

const Navbar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("/");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);



  return (
    <div className="navbar-main-div">
      {/* <Logo /> */}
      <div className={`navbar-div`}>

        {location.pathname !== "/" && <div onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ cursor: 'pointer' }}><Logo2 /></div>}

        <div className={`mobile-menu-btn ${isMenuOpen ? "active" : ""}`} onClick={() => setActiveLink(prev => !prev ? "menu" : prev) || setIsMenuOpen(!isMenuOpen)}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </div>

        <div className={`nav-link-div ${isMenuOpen ? "open" : ""}`} style={{ flex: 1 }}>
          {chatsTab.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className={`nav-link  ${activeLink === item.path && "active"}`}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setIsMenuOpen(false);
              }}
            >
              {item.name}
            </Link>
          ))}

        </div>

      </div>
    </div>
  );
};

export default Navbar;
